function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_67",
  "data-name": "Path 67",
  d: "M619.364,3744.555a9,9,0,1,0,0,12.728A9.005,9.005,0,0,0,619.364,3744.555Zm-6.509-1.081a1.732,1.732,0,1,1-1.741,1.726A1.726,1.726,0,0,1,612.856,3743.475Zm2.769,12.675a.472.472,0,0,1-.537.54h-4.446a.474.474,0,0,1-.539-.54v-1.133a.473.473,0,0,1,.539-.536h.821V3749.7h-.839a.472.472,0,0,1-.537-.539v-1.133a.471.471,0,0,1,.537-.537h3.1a.471.471,0,0,1,.537.537v6.456h.824a.471.471,0,0,1,.537.536Z",
  transform: "translate(-604 -3741.921)"
});

var SvgInfoGray = function SvgInfoGray(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 17.997,
    viewBox: "0 0 18 17.997",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfoGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info_gray.21d661ce.svg";
export { ForwardRef as ReactComponent };